module.exports = __webpack_public_path__ + "img/save.6260342b.png";